import React from "react";
import LearningItemDetailsRoute from "../../components/pages/Learning-item-details/LearningItemDetailsRoute";

function CourseDetails() {
  return (
    <LearningItemDetailsRoute
      expectedType="SIMPLE"
      slugParam="course_slug"
    />
  );
}

export default CourseDetails;
